"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewBulkDrippingCreateSchema extends baseViewSchema_1.BaseViewSchema {
    constructor() {
        super(...arguments);
        this.action = baseSchema_1.ActionsName.VIEW_BULK_DRIPPING_CREATE;
    }
    getDataHubEventData() {
        return super.prepare();
    }
}
exports.default = ViewBulkDrippingCreateSchema;
